import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const addGuarantor = (
  constructPost: ConstructPost,
  uuid: string,
  data: Record<string, any>,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/add-guarantor/${uuid}`,
    { data },
    { preventDefaultErrorToast: true },
  );
